module.exports = __webpack_public_path__ + "static/grass-b24a14bc3ade02385201878a7e29cf85.png";